/* eslint-disable no-underscore-dangle */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ViewContentState,
  ModalStates,
  IContentDocument,
  ICreateContentModalForm,
  IDeleteContent,
} from './interface';

export const initialState: ViewContentState = {
  content: [],
  expertId: '',
  modal: '',
  loading: false,
};

export const viewContentSlice = createSlice({
  name: 'feature/common/content-upload',
  initialState,
  reducers: {
    openModal(state: ViewContentState, action: PayloadAction<string>) {
      state.modal = action.payload;
    },
    closeModal(state: ViewContentState) {
      state.modal = ModalStates.close;
    },
    createContent(state: ViewContentState, _action: PayloadAction<ICreateContentModalForm>) {
      state.loading = true;
    },
    createContentSucceeded(state: ViewContentState, action: PayloadAction<IContentDocument>) {
      const content = action.payload;
      state.content = [
        ...state.content,
        {
          id: content._id,
          baseInfo: {
            title: content.title || '',
            thumbnailUrl: content.thumbnailUrl || ' ',
          },
          description: content.description || '',
          // price: content.price || 0,
          fileType: content.fileType || '',
          fileCategory: content.fileCategory || '',
          contentUrl: content.contentUrl || '',
        },
      ];
      state.loading = false;
      state.modal = ModalStates.close;
    },
    createContentFailed(state: ViewContentState) {
      state.loading = false;
    },
    deleteContent(state: ViewContentState, _action: PayloadAction<IDeleteContent>) {
      state.loading = true;
    },
    deleteContentSucceeded(state: ViewContentState, action: PayloadAction<string>) {
      const id = action.payload;
      const content = state.content.filter((contentItem) => contentItem.id !== id);
      state.modal = ModalStates.close;
      state.content = [...content];
      state.loading = false;
    },
    deleteContentFailed(state: ViewContentState) {
      state.loading = false;
    },

    setExpertId(state: ViewContentState, action: PayloadAction<string>) {
      state.expertId = action.payload;
    },
  },
});

export const { actions: viewContentActions } = viewContentSlice;
